export function getAuthLocalStorageKeys(cognitoUserId, cognitoClientId) {
  const accessTokenKey = `CognitoIdentityServiceProvider.${cognitoClientId}.${cognitoUserId}.accessToken`;
  const idTokenKey = `CognitoIdentityServiceProvider.${cognitoClientId}.${cognitoUserId}.idToken`;
  const refreshTokenKey = `CognitoIdentityServiceProvider.${cognitoClientId}.${cognitoUserId}.refreshToken`;
  const userDataKey = `CognitoIdentityServiceProvider.${cognitoClientId}.${cognitoUserId}.userData`;
  const clockDriftKey = `CognitoIdentityServiceProvider.${cognitoClientId}.${cognitoUserId}.clockDrift`;
  const lastUserKey = `CognitoIdentityServiceProvider.${cognitoClientId}.LastAuthUser`;

  return {
    accessTokenKey,
    idTokenKey,
    refreshTokenKey,
    userDataKey,
    clockDriftKey,
    lastUserKey
  };
}
